import { Mapper } from './mapper';

export const IndicativoAprendiz = Mapper.from([
  [1, 'Contratação direta'],
  [2, 'Contratação indireta'],
]);
